import { render, staticRenderFns } from "./RegistrationConfirmed.vue?vue&type=template&id=f20a715e"
import script from "./RegistrationConfirmed.vue?vue&type=script&lang=js"
export * from "./RegistrationConfirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports